// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { AppEnv } from './app-env';

export const environment = {
    production: false,
    // apiBaseUrl: 'https://dev.designservice.sprintray.com/api/',
    apiBaseUrl: 'https://api-dev.getneer.com/api/',
    apiSprintRayBaseUrl: 'https://dev-neer.sprintray.com/api/v2/',
    appBaseUrl: 'https://dashboard-dev.getneer.com/',
    appAccounts: 'https://dev.account.sprintray.com',
    appEnv: AppEnv.dev,
    sprintRayChatLink: 'https://dev-chat.sprintray.com',

    appSyncRegion: 'us-west-2',
    appSyncGraphQLEndpoint: 'https://24ebi63qizdb7nbkvwachequ7a.appsync-api.us-west-2.amazonaws.com/graphql',

    printPreviewBucketUrl: 'https://s3-us-west-1.amazonaws.com/print-preview-image',
    platformScreenshotBucketUrl: 'https://sprint-ray-files-dev.s3.us-west-2.amazonaws.com/delta',
    axionTrainingLink: 'https://sprintray.axiomtrainingcloud.com/',
    store: 'https://dev.store.ecomm.sprintray.com/',
    storePrint: 'https://dev.store.ecomm.sprintray.com/shop/product-category?cat=114&tag=',
    sprintrayCommunity: 'https://community.sprintray.com/',
    sprintray3DViewerUrl: 'https://3dviewer.dev.designservice.sprintray.com?t=1723457975',

    stripe: {
        paymentMethodConfigurationId: 'pmc_1QyS2OAWMILZMZN7SVJMNs2O',
        buyButtonId: 'buy_btn_1SugNEJwfMrvM8Xct3zjcflC',
        moment5PackPriceId: 'price_1SufVUJwfMrvM8Xcwkndjf8x'
    },
     googleMap: {
        apiKey: 'AIzaSyAF4ZK1WB8Qgx6tn6vq9o47QUpzWip7beM',
        mapId: 'f316a13183a1590f3e69ec41',
        apiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
    },
    launchDarkly: {
        clientKey: '6340c4d453725911a9052628',
    },

    auth0: {
        clientID: '7cgEXA3ed1FKmrlrOiaitPF0GeAmIz3J',
        domain: 'dev-auth.getneer.com',
        audience: 'https://dev-getneer.us.auth0.com/api/v2/',
        scope: 'openid email profile',
        responseType: 'token id_token',
    },

    _3shape: {
        clientID: 'Sprintray.Staging',
        domain: 'staging-identity.3shape.com',
        scope: 'openid api offline_access communicate.connections.manage data.companies.read_only data.users.read_only',
        responseType: 'code',
        authorizePath: 'connect/authorize',
    },

    medit: {
        clientID: '5YfJHOwHUYhhB0cv1Qx5SdZ7nSH4hpyd',
        domain: 'stage-openapi-developers.meditlink.com',
        scope: 'USER GROUP CASE FILE',
        responseType: 'code',
        authorizePath: 'oauth/authorize',
    },

    itero: {
        clientID: 'Gr6l0KfTxiiSiqLvTNNjdu_8WBka',
        domain: 'identity-cus.dev.aligntech.com',
        scope: 'openid',
        responseType: 'code',
        authorizePath: 'oauth2/authorize',
    },

    cloudDriveExternalProviders: {
        medit: {
            clientId: 'EQprqaLzEvJyCgGb8C5UFeb1rngQl9eS',
            name: 'Medit',
        },
        _3shape: {
            clientId: '2y0fvc4jkh1xxKL380aNQf2g5O6RTg2T',
            name: '3Shape',
        },
        _3shapeDesktop: {
            clientId: 'cq4k6JooxaREZTnh6Ba2yXzpE7l6UlfA',
            name: '3Shape Desktop',
        },
        dexis: {
            clientId: 'VqfdtPxq3fsqUbuJbak8KTfk09HGl79z',
            name: 'Dexis',
        },
        exocad: {
            clientId: 'zjHx8jfw0EUbXYZAwj7jGBHmo9mlvYhi',
            name: 'Exocad',
            disabled: false,
        },
        envista: {
            clientId: '0UMsTDLSA7jWQfM2W9T34Y374iNEr072',
            name: 'Envista',
        },
        Itero: {
            clientId: 'N/A',
            name: 'iTero',
        },
    },

    organizationIds: {
        aspen: 'd2c90157-d6e0-44f0-bef7-d90868c68389',
        pacific: '3cda86d9-292e-48ef-8d8c-ecb3bd0e65d7',
        pds: '467874c8-d606-4e0d-b526-d1ba47de6019',
    },
    aicad: {
        url: 'https://ai-cad.dev.designservice.sprintray.com/index.html#/',
        apiBaseUrl: 'https://flbb81b96d.execute-api.us-west-2.amazonaws.com/dev',
    },
    studio: {
        url: 'https://ai-cad.dev.designservice.sprintray.com/studio/index.html',
    },
};
